import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { map } from 'rxjs';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';
import { AuthService } from '../auth-service';

const Bundle_DOMAIN = 2802;

@Injectable({
  providedIn: 'root',
})
export class ActionsService {
  private httpClient = inject(HttpClient);
  private API = environment.workflowApiUrl;
  private authService = inject(AuthService);

  printOrder(orderId: string, comment: string) {
    const token = this.authService.getAccessToken();
    let headers = new HttpHeaders();
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }
    return this.httpClient.put(`${this.API}/orders/${orderId}/print`, { comment }, { headers });
  }
  repackageOrder(orderId: string, comment: string) {
    const token = this.authService.getAccessToken();
    let headers = new HttpHeaders();
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }
    return this.httpClient.put(`${this.API}/orders/${orderId}/repackage`, { comment }, { headers });
  }
  confirmReview(orderId: string, comment: string) {
    const token = this.authService.getAccessToken();
    let headers = new HttpHeaders();
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }
    return this.httpClient.put(`${this.API}/orders/${orderId}/review/confirm`, { comment }, { headers });
  }

  shipOrder(orderId: string, comment: string) {
    console.log('orderId: ', orderId);
    console.log('comment: ', comment);
    const token = this.authService.getAccessToken();
    let headers = new HttpHeaders();
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }
    return this.httpClient.put(`${this.API}/orders/${orderId}/ship`, { comment }, { headers });
  }
}
